/** @jsxImportSource @emotion/react */
import { Breadcrumbs, Anchor, Text, useMantineTheme } from "@mantine/core";
import { Link, To } from "react-router-dom";
import { IconHome, IconSettings } from "@tabler/icons-react";
import styled from "@emotion/styled";

// Breadcrumb link type (path is optional for last item)
export interface BreadcrumbLink {
  label: string;
  path?: To;
}

// Props for BenchSettingsBreadcrumbs
interface BenchSettingsBreadcrumbsProps {
  links: BreadcrumbLink[];
}

// Styled Breadcrumbs container
const StyledBreadcrumbs = styled(Breadcrumbs)`
  font-size: 18px;
  font-weight: 500;
 // margin-top: 8px;
 // margin-bottom: 16px;
`;

const BenchSettingsBreadcrumbs: React.FC<BenchSettingsBreadcrumbsProps> = ({ links }) => {
  const theme = useMantineTheme();
  return (
    <StyledBreadcrumbs separator={<span style={{ fontSize: 18 }}>{">"}</span>}>
      {/* Fixed Home */}
      <Anchor
        component={Link}
        to="/settingoverview"
        sx={{
          display: "flex",
          alignItems: "center",
          fontWeight: 500,
          textDecoration: "none",
        }}
      >
        <IconSettings size={20} style={{ marginRight: 4 }} />
      </Anchor>

      {/* Dynamic links */}
      {links.map((link, index) => {
        // If path exists, render Link; else render plain Text
        return link.path ? (
          <Anchor
            key={index}
            component={Link}
            to={link.path}
            sx={{
              display: "flex",
              alignItems: "center",
              fontWeight: 500,
              textDecoration: "none",
              marginLeft: 1,
              color: "black",
              "&:hover": {
                textDecoration: "none"
              }
            }}
          >
            {link.label}
          </Anchor>
        ) : (
          <Text
            key={index}

            sx={{
              display: "flex",
              alignItems: "center",
              fontWeight: 500,
              color: theme.colors.brand[4],
              marginLeft: 1,
              "&:hover": {
                textDecoration: "underline"
              }
            }}
          >
            {link.label}
          </Text>
        );
      })}
    </StyledBreadcrumbs>
  );
};

export default BenchSettingsBreadcrumbs;
